import PropTypes from 'prop-types';
import React from 'react';
import FullPageLayout from '../layouts/fullPageLayout';
import ForestAnimationView from './components/ForestAnimationView';
import withBlockedBackNavigation from '../utils/withBlockedBackNavigation';

const InterstitialView = (props) => (
    <div>
        <FullPageLayout>
            <ForestAnimationView
                onAnimationEnd={props.goToNextPage}
            />
        </FullPageLayout>
    </div>
);

InterstitialView.propTypes = {
    goToNextPage: PropTypes.func.isRequired,
};

export default withBlockedBackNavigation(InterstitialView);
